import { incomeTaxYear } from "@stb/jurisdiction-au/income-tax"

import type { Locale } from "@/core/i18n/locale"

import { PROVISIONAL_ZH } from "../../content/zh/pay-calculator-copy"
import { displayYear } from "../home/home-content"

/** "2026-27" -> "2025–26" */
const previousYear = (fy: string) => {
  const start = Number(fy.slice(0, 4))
  return `${start - 1}–${String(start).slice(2)}`
}

/** What the ATO has not yet published, by the engine's `provisional` rule name (pay and sole trader calculators). */
export const PROVISIONAL_TEXT: Record<string, (fy: string, locale?: Locale) => string> = {
  "medicare-levy-thresholds": (fy, locale = "en") =>
    locale === "zh"
      ? PROVISIONAL_ZH["medicare-levy-thresholds"]({ fy: displayYear(fy), prev: previousYear(fy) })
      : `${displayYear(fy)} Medicare thresholds not yet published by the ATO; using ${previousYear(fy)} values.`,
  "foreign-resident-brackets": (fy, locale = "en") =>
    locale === "zh"
      ? PROVISIONAL_ZH["foreign-resident-brackets"]({
          fy: displayYear(fy),
          prev: previousYear(fy),
        })
      : `${displayYear(fy)} foreign resident rates not yet published by the ATO; using ${previousYear(fy)} values.`,
  "working-holiday-brackets": (fy, locale = "en") =>
    locale === "zh"
      ? PROVISIONAL_ZH["working-holiday-brackets"]({ fy: displayYear(fy), prev: previousYear(fy) })
      : `${displayYear(fy)} working holiday maker rates not yet published by the ATO; using ${previousYear(fy)} values.`,
  "working-holiday-medicare-lito": (_fy, locale = "en") =>
    locale === "zh"
      ? PROVISIONAL_ZH["working-holiday-medicare-lito"]({ fy: "", prev: "" })
      : "The ATO page does not say whether working holiday makers get Medicare or the low income offset; we assume neither.",
  // Reachable: the engine flags it whenever a year's standard deduction rule is not marked published.
  "standard-deduction": (fy, locale = "en") => {
    const amount = `A$${(incomeTaxYear(fy).standardDeduction?.maxDollars ?? 0).toLocaleString("en-AU")}`
    return locale === "zh"
      ? PROVISIONAL_ZH["standard-deduction"]({ fy: displayYear(fy), prev: "", amount })
      : `The ${amount} standard deduction is announced for ${displayYear(fy)}; we have not yet confirmed it against the legislation.`
  },
}
